import ReportHtml from './ReportHtml';

export default {
  chart: () => import('./ReportChart'),
  dashboard: () => import('./ReportDashboard'),
  decisionTree: () => import('./decisionTree/ReportDecisionTree'),
  embed: () => import('./ReportEmbed'),
  facet: () => import('./ReportFacet'),
  funnel: () => import('./ReportFunnel'),
  header: ReportHtml,
  html: ReportHtml,
  number: () => import('./ReportNumber'),
  percentage: () => import('./ReportNumber'),
  sentMessages: () => import('./ReportSentMessages'),
  table: () => import('./ReportTable'),
  ticker: () => import('./ReportTicker'),
  workflow: () => import('./ReportWorkflow'),
};
